import aboutImage from "../../assets/homeabout.png";

function HomeAboutSchool() {
  return (
    <section
      className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
      aria-labelledby="home-about-school-heading"
    >
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent" aria-hidden />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-14 xl:gap-16">
          <div className="min-w-0 max-w-2xl text-left lg:max-w-none xl:pr-4">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
              About Altus
            </p>
            <h2
              id="home-about-school-heading"
              className="mt-4 text-balance text-center text-3xl font-bold tracking-tight text-ink sm:text-left sm:text-4xl md:text-[2.375rem] md:leading-tight"
            >
              Welcome to Altus Online School
            </h2>
            <p className="mt-6 text-pretty text-base leading-relaxed text-ink/75 sm:mt-8 sm:text-lg">
              Altus Online School is a virtual campus for students who value a more
              flexible, personalised approach to learning. From K to Grade 12, we
              bridge the gap between the academic rigor of a traditional classroom
              and the freedom of modern digital education. We provide a truly
              student-first environment, built specifically for those who seek an
              academic path as unique as their own ambitions.
            </p>
            <p className="mt-4 text-pretty text-base leading-relaxed text-ink/75 sm:text-lg">
              Our school is on a mission to support students whose talents, goals,
              or circumstances require an alternative to rigid, traditional school
              institutions. Whether you are an athlete or artist managing intensive
              training, or a learner seeking a customized pace and subject
              flexibility, education here is structured around you. You are
              empowered to adjust your schedule and balance academic success with
              your personal journey.
            </p>
            <p className="mt-4 text-pretty text-base leading-relaxed text-ink/75 sm:text-lg">
              From Cambridge and CBSE pathways to NIOS and NEP-aligned options, AOS
              offers recognised qualifications, certified support, and clear
              university pathways. Backed by experienced educators and strong
              academic oversight, AOS builds a truly holistic future for every
              learner.
            </p>
          </div>

          <div className="relative min-h-0 h-64 w-full sm:h-72 lg:h-[min(100%,28rem)] lg:min-h-[18rem]">
            <div className="relative h-full min-h-[16rem] overflow-hidden rounded-2xl border border-brand/10 bg-brand-light/30 shadow-[0_18px_44px_-16px_rgba(30,22,51,0.14)] ring-1 ring-brand/5">
              <img
                src={aboutImage}
                alt="Students in uniform seated at desks in a bright classroom, focused on learning"
                className="absolute inset-0 h-full w-full object-cover object-center"
                width={1200}
                height={800}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeAboutSchool;
